export const messages = {
  en: {
    workType: {
      search: {
        title: 'Search Conditions',
        typeName: 'Type Name'
      },
      list: {
        title: 'Work Order Types'
      },
      table: {
        typeName: 'Type Name',
        deduction: 'Deduction',
        smsWay: 'Notification Method',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      form: {
        typeName: 'Type Name',
        deduction: 'Deduction',
        smsWay: 'Notification Method',
        remark: 'Remark'
      },
      placeholder: {
        typeName: 'Please enter type name',
        deduction: 'Please select deduction',
        smsWay: 'Please select notification method',
        remark: 'Optional, please enter remark'
      },
      validate: {
        typeName: 'Type name is required',
        typeNameMax: 'Type name cannot exceed 200 characters',
        deduction: 'Deduction is required',
        smsWay: 'Notification method is required',
        wtId: 'ID is required'
      },
      tip: {
        deduction: 'After selecting deduction, the copy recipient will deduct money according to the task completion!',
        wechat: 'Need to configure the official account in the system, the official account is a certified service account, and the employee has done employee certification',
        aliSms: 'Need to configure Alibaba Cloud SMS information in the system community configuration, the template is work order pending template and work order completion template'
      },
      yes: 'Yes',
      no: 'No',
      wechat: 'WeChat',
      aliSms: 'Ali SMS',
      workLicense: 'Employee License',
      unknown: 'Unknown',
      add: {
        title: 'Add Work Order Type',
        success: 'Add success',
        error: 'Add failed'
      },
      edit: {
        title: 'Edit Work Order Type',
        success: 'Edit success',
        error: 'Edit failed'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this work order type?',
        success: 'Delete success',
        error: 'Delete failed'
      },
      fetchError: 'Failed to fetch work order types'
    }
  },
  zh: {
    workType: {
      search: {
        title: '查询条件',
        typeName: '类型名称'
      },
      list: {
        title: '工作单类型'
      },
      table: {
        typeName: '类型名称',
        deduction: '扣款',
        smsWay: '通知方式',
        createTime: '创建时间',
        remark: '备注'
      },
      form: {
        typeName: '类型名称',
        deduction: '扣款',
        smsWay: '通知方式',
        remark: '备注'
      },
      placeholder: {
        typeName: '请输入类型名称',
        deduction: '请选择扣款',
        smsWay: '请选择通知方式',
        remark: '选填，请输入备注'
      },
      validate: {
        typeName: '类型名称不能为空',
        typeNameMax: '类型名称不能超过200个字符',
        deduction: '扣款不能为空',
        smsWay: '通知方式不能为空',
        wtId: '编号不能为空'
      },
      tip: {
        deduction: '选择扣款后，抄送人会根据任务完成情况，相应的扣款！',
        wechat: '需要在系统下公众号中配置公众号，公众号为认证过的服务号，并且员工做了员工认证',
        aliSms: '需要在系统下园区配置中配置阿里云短信信息，模版为日志待处理模版和日志完成模版'
      },
      yes: '是',
      no: '否',
      wechat: '微信',
      aliSms: '阿里短信',
      workLicense: '员工工牌',
      unknown: '未知',
      add: {
        title: '添加工作单类型',
        success: '添加成功',
        error: '添加失败'
      },
      edit: {
        title: '修改工作单类型',
        success: '修改成功',
        error: '修改失败'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除此工作单类型吗？',
        success: '删除成功',
        error: '删除失败'
      },
      fetchError: '获取工作单类型失败'
    }
  }
}